<script>
import { markupParser } from '@/shared/lib/markup';

const createRenderers = (linkTarget) => {
  const renderText = (h, token) => token.value;

  const renderBold = (h, token) => h('strong', token.value);

  const renderLink = (h, token) => h('a', {
    class: 'markup-message__link',
    attrs: linkTarget === '_blank'
      ? { href: token.url, target: '_blank', rel: 'noopener noreferrer' }
      : { href: token.url },
  }, token.label);

  const inlineRenderers = {
    text: renderText,
    bold: renderBold,
    link: renderLink,
  };

  const renderInline = (h, tokens) => tokens.map((token) => (inlineRenderers[token.type] || renderText)(h, token));

  const renderList = (h, block, index) => {
    const items = block.items.map((inline, itemIndex) => h('li', { key: itemIndex }, renderInline(h, inline)));
    return h(block.listType, { key: index }, items);
  };

  const renderParagraph = (h, block, index) => {
    const lineNodes = [];
    block.lines.forEach((inline, lineIndex) => {
      if (lineIndex > 0) {
        lineNodes.push(h('br'));
      }
      lineNodes.push(...renderInline(h, inline));
    });

    return h('p', { key: index }, lineNodes);
  };

  return {
    list: renderList,
    paragraph: renderParagraph,
  };
};

export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    linkTarget: {
      type: String,
      default: '_self',
      validator: (value) => ['_self', '_blank'].includes(value),
    },
  },
  mixins: [ markupParser ],
  render(h) {
    const blocks = this.parseMarkup(this.text);
    const blockRenderers = createRenderers(this.linkTarget);
    return h('div', { class: 'markup-message' }, blocks.map((block, index) => blockRenderers[block.type](h, block, index)));
  },
};
</script>

<style lang="scss" scoped>
.markup-message {
  p {
    margin-bottom: 0;
  }

  &__link {
    display: inline-block;
    background-color: #0A77FF;
    padding: 2px 10px;
    border-radius: 12px;
    color: #fff;
  }
}
</style>
